export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#22D3EE" />
        <stop offset="1" stopColor="#2563EB" />
      </linearGradient>
    </defs>
    <path d="M50 22a21 21 0 1 0 3 15" fill="none" stroke="url(#lm-g)" strokeWidth="5" strokeLinecap="round" />
    <path d="M44 14l9 7-10 4z" fill="#22D3EE" />
    <path d="M21 46l11-28 11 28h-6l-2-6h-6l-2 6zm10-11h4l-2-6z" fill="#0F172A" />
  </svg>
);

export const Logo = ({ testId = "navbar-logo", small = false }) => (
  <a href="/" data-testid={testId} className="group flex items-center gap-2.5">
    <LogoMark className={`${small ? "h-8 w-8" : "h-10 w-10"} transition-transform duration-500 group-hover:rotate-[-25deg]`} />
    <span className="leading-none">
      <span className="font-display block text-lg font-extrabold tracking-tight text-slate-900">
        Start-<span className="text-blue-600">A</span>-TE
      </span>
      <span className="font-mono-x block text-[10px] uppercase tracking-[0.28em] text-slate-600">Traffic Exchange Software</span>
    </span>
  </a>
);
